<template>
    <div class="animated fadeIn lapeks-page">
        <div class="filter-card mb-3">
            <div class="d-flex align-items-center justify-content-between mb-3">
                <h4 class="page-title mb-0">Laporan BPKB Macet</h4>
                <button type="button" class="btn btn-filter-reset" name="downloadExcelBtn" :disabled="isLoading" @click="confirmLaporanDownload()">
                    <i class="fa fa-download mr-2"></i>Download Excel
                </button>
            </div>

            <div class="filter-section">
                <div class="filter-controls-row">
                    <div class="filter-field">
                        <span class="filter-sublabel">Keterlambatan</span>
                        <div class="range-group">
                            <span class="range-sep">H+</span>
                            <b-form-input v-model="input.filterFromDays" name="filterFromDays" type="number" class="filter-input input-days"></b-form-input>
                            <span class="range-sep">s/d H+</span>
                            <b-form-input v-model="input.filterToDays" name="filterToDays" type="number" class="filter-input input-days"></b-form-input>
                        </div>
                    </div>

                    <div class="filter-field">
                        <span class="filter-sublabel">Cabang</span>
                        <div class="filter-multiselect-wrapper">
                            <multiselect
                                name="filterCabang"
                                v-model="input.filterCabang"
                                :options="cabangOption"
                                :internal-search="true"
                                :allow-empty="true"
                                deselect-label=""
                                select-label=""
                                label="name"
                                track-by="name"
                                placeholder="Cabang"
                                :disabled="!showWebLaporan"
                                @input="onCabangChange"
                            />
                        </div>
                    </div>

                    <button type="button" class="btn btn-filter-search" name="searchTableBtn" :disabled="isLoading" @click="onSearch()">
                        <i class="fa fa-search"></i>
                    </button>
                    <button type="button" class="btn btn-filter-reset" name="resetTableBtn" :disabled="isLoading || !showWebLaporan" @click="onResetAll()">Reset</button>
                </div>
            </div>
        </div>
        <div v-if="showWebLaporan">
            <div class="text-center" v-if="isLoading">
                <b-spinner class="align-middle mb-4"></b-spinner>
                <p class="mb-0">Sedang memproses, mohon menunggu...</p>
            </div>
            <div v-else>
                <b-row>
                    <b-col lg="4" sm="6" cols="12">
                        <div class="custom-card-dashboard balance-card">
                            <div class="d-flex align-items-center">
                                <div class="card-icon">
                                    <i class="mb-2 fa fa-balance-scale"></i>
                                </div>
                                <div class="card-data ml-4">
                                    <p class="mb-0 text-muted">Total BPKB Macet</p>
                                    <strong class="mb-0">
                                        {{$helper.addThousandSeparator(dataBpkbMacetAll.jumlah)}}
                                    </strong>
                                </div>
                            </div>
                        </div>
                    </b-col>
                    <b-col lg="4" sm="6" cols="12">
                        <div class="custom-card-dashboard balance-card">
                            <div class="d-flex align-items-center">
                                <div class="card-icon">
                                    <i class="mb-2 fa fa-money"></i>
                                </div>
                                <div class="card-data ml-4">
                                    <p class="mb-0 text-muted">Nominal BPKB Macet</p>
                                    <strong class="mb-0">
                                        Rp. {{$helper.addThousandSeparator(dataBpkbMacetAll.pokokEfektif)}}
                                    </strong>
                                </div>
                            </div>
                        </div>
                    </b-col>
                </b-row>
                <div class="table-card">
                    <div class="table-responsive-wrapper">
                    <b-table show-empty hover
                        :busy="isBusy"
                        :items="dataBpkbMacet" 
                        :fields="fields" 
                        :currentPage="currentPage" 
                        :perPage="perPage"
                        responsive class="custom-data-table mb-0">
                        <template v-slot:table-busy>
                            <div class="text-center text-muted my-4 py-3">
                                <b-spinner class="align-middle mr-2" variant="primary" small></b-spinner>
                                <span>Loading data...</span>
                            </div>
                        </template>
                        <template v-slot:empty>
                            Tidak ada data BPKB macet.
                        </template>
                        <template v-slot:cell(jumlah)="row">
                            <div class="text-right no-wrap">
                                {{ $helper.addThousandSeparator(row.item.jumlah) }}                 
                            </div>
                        </template>
                        <template v-slot:cell(pokokEfektif)="row">
                            <div class="text-right no-wrap" v-if="row.item.pokokEfektif == null">{{$helper.addThousandSeparator(row.item.pokokEfektif)}} </div>
                            <div class="text-right no-wrap" v-else-if="row.item.pokokEfektif < 0">- Rp{{$helper.addThousandSeparator(row.item.pokokEfektif).replace("-", "")}}</div>
                            <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.pokokEfektif)}} </div>
                        </template>
                    </b-table>
                    </div>

                    <div class="table-pagination-footer d-flex align-items-center justify-content-between">
                        <div class="limit-wrapper d-flex align-items-center">
                            <span class="limit-label mr-2">Tampilkan</span>
                            <b-form-select v-model="input.show" id="showItems" @change="onLimitChange" :options="options" class="limit-select">
                                <template v-slot:first>
                                    <b-form-select-option :value="null" disabled />
                                </template>
                            </b-form-select>
                            <span class="entries-info ml-3">{{ totalViewText }}</span>
                        </div>
                        <b-pagination class="custom-pagination mb-0"
                            v-model="currentPage"
                            :total-rows="rows"
                            :per-page="perPage"
                            aria-controls="my-table"
                            @input="onPageChange"
                            prev-text="‹"
                            next-text="›"
                            hide-goto-end-buttons
                        ></b-pagination>
                    </div>
                </div>
            </div>
        </div>
        <b-modal id="modal-web-password" content-class="lapeks-modal" @shown="focusLaporanWebPassword" title="Confirm Web Laporan Pemasukan" :no-close-on-backdrop="isSubmitting" :no-close-on-esc="isSubmitting"
            :hide-header-close="isSubmitting">
            <b-form id="webPasswordForm" @submit.prevent="openLaporanWeb">
                <div class="form-content-wrapper mb-0">
                    <b-form-group label="Password" class="mb-0">
                        <b-form-input ref="passwordWeb"
                        v-model="input.passwordWeb"
                        name="passwordWeb"
                        type="password"
                        required
                        ></b-form-input>
                    </b-form-group>
                </div>
            </b-form>
            <template v-slot:modal-footer="{ ok, cancel }">
                <b-button variant="secondary" name="cancelWebPasswordBtn" :disabled="isSubmitting" @click="cancel()">
                    Cancel
                </b-button>
                <b-button variant="pgiBtn" name="okeWebPasswordBtn" :disabled="isSubmitting" type="submit" form="webPasswordForm">
                    <b-spinner small type="grow" v-if="isSubmitting"></b-spinner>
                    {{isSubmitting ? 'Memproses...' : 'Submit'}}
                </b-button>
            </template>
        </b-modal>
        <b-modal id="modal-download-password" content-class="lapeks-modal" @shown="focusLaporanDownloadPassword" title="Confirm Download Laporan Pemasukan" :no-close-on-backdrop="isSubmitting" :no-close-on-esc="isSubmitting"
            :hide-header-close="isSubmitting">
            <b-form id="downloadExcelPasswordForm" @submit.prevent="openLaporanDownload">
                <div class="form-content-wrapper mb-0">
                    <b-form-group label="Password" class="mb-0">
                        <b-form-input ref="passwordDownload"
                        v-model="input.passwordDownload"
                        name="passwordDownload"
                        type="password"
                        required
                        ></b-form-input>
                    </b-form-group>
                </div>
            </b-form>
            <template v-slot:modal-footer="{ ok, cancel }">
                <b-button variant="secondary" name="cancelDownloadPasswordBtn" :disabled="isSubmitting" @click="cancel()">
                    Cancel
                </b-button>
                <b-button variant="pgiBtn" name="okeDownloadPasswordBtn" :disabled="isSubmitting" type="submit" form="downloadExcelPasswordForm">
                    <b-spinner small type="grow" v-if="isSubmitting"></b-spinner>
                    {{isSubmitting ? 'Memproses...' : 'Submit'}}
                </b-button>
            </template>
        </b-modal>
        <b-modal id="modal-download-excel" content-class="lapeks-modal" centered title="Download Excel" hide-footer no-close-on-backdrop>
            <div class="text-center" v-if="isLoading == true">
                <b-spinner class="align-middle mb-4"></b-spinner>
                <p class="mb-0">Sedang memproses, mohon menunggu...</p>
            </div>
            <div class="show-btn-download" v-else>
                <p class="">
                    Silakan download dengan klik tombol dibawah ini :
                </p>
                <b-button variant="pgiBtn" class="mb-0 download-btn">
                    <a v-bind:href="$baseFilePath + filePathDownload" download>
                        <i class="fa fa-download mr-2"></i>
                        Download Excel
                    </a>
                </b-button>
            </div>
        </b-modal>
    </div>
</template>

<script>

export default {
    name: 'daftar-bpkb-macet',
    data(){
        return{
            input:{
                filterFromDays: null,
                filterToDays: null,
                passwordDownload: "",
                passwordWeb: "",
                //
                
                show: 10,
                filterCabang: null,
            },

            //
            isLoading: false,
            filePathDownload: "",
            query: "",
            isSubmitting: false,
            showWebLaporan: false,
            periodeStart: '',
            periodeEnd: '',
            isBusy: true,
            todayDate: '',
            fields: [
                { key: "cabangName", label: "Cabang"},
                { key: "jumlah", label: "Jumlah Macet", sortable: true },
                { key: "pokokEfektif", label: "Nominal Macet", sortable: true },
            ],
            options: [
                { value: 10, text: '10'},
                { value: 20, text: '20'},
                { value: 30, text: '30'},
                { value: 40, text: '40'},
                { value: 50, text: '50'},
            ],
            dataBpkbMacetAll : [],
            dataBpkbMacet: [],
            filePath: "",
            cabangOption: [],
            currentPage: 1,
            perPage: 10,
            rows: null,
            totalViewText: "",
            page: '',
            size: '',
        }
    }, 
    methods: {
        focusLaporanWebPassword(){
            this.$refs.passwordWeb.focus()
        },
        focusLaporanDownloadPassword(){
            this.$refs.passwordDownload.focus()
        },
        confirmLaporanWeb(){
            if((this.input.filterToDays == null || this.input.filterFromDays == null) || (this.input.filterToDays == "" || this.input.filterFromDays == "")){
                this.$helper.toastErr(this, "Mohon isi hari mulai dan hari akhir filter!")
            }else if(((this.input.filterToDays != "" && this.input.filterFromDays != "") || (this.input.filterToDays != null && this.input.filterFromDays != null)) && (Number(this.input.filterToDays) < Number(this.input.filterFromDays))){
                this.$helper.toastErr(this, "Hari akhir lebih kecil daripada hari mulai!")
            }else{
                if(localStorage.getItem('isauthorized') == 'true'){
                    this.openLaporanWeb()
                    this.input.passwordWeb = localStorage.getItem('lapeksPassword')
                }else{
                    this.$bvModal.show('modal-web-password')
                }
            }
        },

        openLaporanWeb(){
            this.showWebLaporan = true
            this.isLoading = true
            this.$bvModal.hide('modal-web-password')
            setTimeout(() => { this.axiosLaporanWeb() }, 500)
        },

        axiosLaporanWeb(){
            let getCabang = this.getOptionCabang()

            let getDataBpkbMacet = this.$axios.get(`laporan-eksekutif/bpkb-macet?hDari=${this.input.filterFromDays}&hSampai=${this.input.filterToDays}&password=${this.input.passwordWeb}`).then(response => {
                this.dataBpkbMacetAll = response.data
                this.dataBpkbMacet = response.data.entries
                this.updateTotalItem()
                console.log(response.data)
            })

            Promise.all([getCabang, getDataBpkbMacet]).then(() => {
                this.input.filterCabang = null
                this.isLoading = false
                this.isBusy = false
                if(localStorage.getItem('isauthorized') == 'false'){
                    localStorage.setItem('lapeksPassword', this.input.passwordWeb)
                    localStorage.setItem('isauthorized', 'true')
                }
                this.input.passwordWeb = ""
                this.periodeStart = this.input.filterFromDays
                this.periodeEnd = this.input.filterToDays

                var todayFormat = new Date();
                var dd = todayFormat.getDate();
                var mm = todayFormat.getMonth()+1; //January is 0!
                var yyyy = todayFormat.getFullYear();
                if(dd<10){
                        dd='0'+dd
                    } 
                    if(mm<10){
                        mm='0'+mm
                    } 

                todayFormat = yyyy+'-'+mm+'-'+dd;
                this.todayDate = todayFormat
            })
            .catch(error => {
                console.log(error)
                this.$helper.toastErr(this, error.response.data.reason)
                this.input.passwordWeb = ""
                this.showWebLaporan = false
                this.isLoading = false
            })
        },

        getOptionCabang(){
            if(this.cabangOption.length == 0){
                this.$axios.get("cabang/all-selection").then(response => {
                    response.data.forEach((element) => {
                        if(element.id != this.srcCabangId)
                            this.cabangOption.push(element)
                    })
                })
            }
        },

        confirmLaporanDownload(){
            this.showWebLaporan = false
            if((!this.$helper.isNotNullAndNotEmpty(this.input.filterToDays) || !this.$helper.isNotNullAndNotEmpty(this.input.filterFromDays))){
                this.$helper.toastErr(this, "Mohon isi hari mulai dan hari akhir filter!")
            }else if((this.$helper.isNotNullAndNotEmpty(this.input.filterFromDays) && this.$helper.isNotNullAndNotEmpty(this.input.filterToDays)) && (Number(this.input.filterToDays) < Number(this.input.filterFromDays))){
                this.$helper.toastErr(this, "Hari akhir lebih kecil daripada hari mulai!")
            }else{
                if(localStorage.getItem('isauthorized') == 'true'){
                    this.openLaporanDownload()
                    this.input.passwordDownload = localStorage.getItem('lapeksPassword')
                }else{
                    this.$bvModal.show('modal-download-password')
                }
            }
        },

        openLaporanDownload(){
            this.isLoading = true
            this.$bvModal.show('modal-download-excel')
            this.$bvModal.hide('modal-download-password')
            setTimeout(() => { this.axiosLaporanDownload() }, 500)
        },

        axiosLaporanDownload(){
            this.$axios.get(`laporan-eksekutif/bpkb-macet/dl?hDari=${this.input.filterFromDays}&hSampai=${this.input.filterToDays}&password=${this.input.passwordDownload}`).then(response => {
                this.filePathDownload = response.data
                if(localStorage.getItem('isauthorized') == 'false'){
                    localStorage.setItem('lapeksPassword', this.input.passwordDownload)
                    localStorage.setItem('isauthorized', 'true')
                }
                this.input.passwordDownload = ""
            })
            .catch(error => {
                console.log(error)
                console.log(error.response.data.reason)
                this.input.passwordDownload = ""
                this.$bvModal.hide('modal-download-excel')
                this.$helper.toastErr(this, error.response.data.reason)
            })
            .finally(() => {
                this.isLoading = false
            })
        },

        //----------------- Fungsi Ambil Data Daftar Gadai -----------------

        getDataBpkbMacet(){
            this.dataBpkbMacet = this.dataBpkbMacetAll.entries
            this.toggleBusy()
            this.updateTotalItem()
        },

        //----------------- Fungsi Pagination, Sorting, dan loading -----------------

        onLimitChange(){
            this.perPage = this.input.show
            this.onPageChange()
        },

        onPageChange(){
            let prevLimit = null
            let limit = null
            prevLimit = (this.currentPage-1) * this.input.show + 1
            limit = (this.currentPage-1) * this.input.show + this.input.show
            if(limit > this.rows) limit = this.rows
            this.totalViewText = "Menampilkan "+ prevLimit + " - " + limit + " dari " + this.rows + " entri"
        },

        //----------------- Aksi baris filter -----------------

        // Rentang H+ adalah parameter server, jadi Search selalu mengambil ulang data.
        // Password diminta sekali; setelah itu dipakai ulang dari localStorage.
        onSearch(){
            this.confirmLaporanWeb()
        },

        // Filter cabang murni sisi klien, langsung berlaku tanpa perlu Search.
        onCabangChange(){
            if(!this.showWebLaporan) return
            if(this.input.filterCabang == null){
                this.onReset()
            }else{
                this.onFilter()
            }
        },

        onResetAll(){
            this.input.filterCabang = null
            this.onReset()
        },

        onReset(){
            this.filter = ""
            this.toggleBusy()
            this.getDataBpkbMacet()
        },
        
        onFilter(){
            
            if(this.input.filterCabang == null){
                this.$helper.toastErr(this, "Silakan isi nama cabang terlebih dahulu!")
            }else{
                let filteredArray = []

                for (var x of this.dataBpkbMacetAll.entries) {
                    if(x.cabangId == this.input.filterCabang.id){
                        filteredArray.push(x)
                    }
                }
                
                this.dataBpkbMacet = filteredArray
                this.onFiltered(this.dataBpkbMacet)
            }
        },

        onFiltered(filteredItems) {
            this.rows = filteredItems.length
            this.currentPage = 1
            this.perPage = this.input.show
            let prevLimit = null
            let limit = null
            
            prevLimit = (this.currentPage-1) * this.rows + 1
            limit = (this.currentPage-1) * this.rows + this.rows
            if (limit > this.input.show) limit = this.input.show
            this.totalViewText = "Menampilkan "+ prevLimit + " - " + limit + " dari " + this.rows + " entri"
        },

        //----------------- Fungsi Pindah Halaman dan Fungsi Lain -----------------

        toggleBusy() {
            if(this.isBusy == true) this.isBusy = false
            else this.isBusy = true
        },

        updateTotalItem(){
            this.rows = this.dataBpkbMacet.length
            if (this.perPage > this.rows) this.perPage = this.rows
            this.totalViewText = "Menampilkan 1 - " + this.perPage + " dari " + this.rows + " entri"
        },


    },
}
</script>


<style lang="scss" scoped>
// Design System Tokens (Deep Pine Palette)
$deep-pine: #023831;
$deep-pine-hover: #0A5247;
$brass: #C69B6B;
$ink-body: #16302B;
$ink-heading: #072D28;
$ink-muted: #7E918B;
$line-border: #E2E7E3;
$input-border: #D8E2DC;

.lapeks-page { padding-bottom: 30px; }

.filter-card,
.table-card {
    background-color: #FFFFFF;
    border: 1px solid $line-border;
    border-radius: 12px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.02);
}

.filter-card { padding: 22px 24px 24px; }
.table-card  { padding: 0; overflow: hidden; margin-bottom: 16px; }

.page-title {
    font-size: 20px;
    font-weight: 700;
    color: $ink-heading;
    letter-spacing: -0.01em;
}

// Label varian laporan di dalam kartu tabel
.table-card-label {
    position: relative;
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.14em;
    text-transform: uppercase;
    color: $ink-heading;
    padding: 18px 20px 12px 32px;
    margin: 0;
    border-bottom: 1px solid #EDF2EF;

    &::before {
        content: "";
        position: absolute;
        left: 20px;
        top: 19px;
        width: 3px;
        height: 13px;
        border-radius: 2px;
        background-color: $brass;
    }
}

// Filter
.filter-section {
    .filter-controls-row {
        display: flex;
        align-items: flex-end;
        gap: 12px;
        flex-wrap: wrap;
    }

    .filter-field {
        display: flex;
        flex-direction: column;
        gap: 4px;
    }

    .filter-sublabel {
        font-size: 11.5px;
        font-weight: 600;
        color: $ink-body;
    }

    .range-group {
        display: flex;
        align-items: center;
        gap: 8px;
    }

    .range-sep { font-size: 12px; color: $ink-muted; flex-shrink: 0; }

    ::v-deep .filter-input,
    .filter-select {
        height: 38px;
        border-radius: 8px;
        border: 1px solid $input-border;
        font-size: 13px;
        color: $ink-body;
        padding: 6px 14px;
        background-color: #FFFFFF;

        &::placeholder { color: #8C9F98; font-size: 12.5px; }

        &:focus {
            border-color: $deep-pine;
            box-shadow: 0 0 0 2px rgba(2, 56, 49, 0.1);
            outline: none;
        }
    }

    ::v-deep .filter-input.input-days { width: 110px; }
    .filter-select { padding: 6px 12px; width: 180px; max-width: 100%; }

    .filter-multiselect-wrapper {
        width: 220px;
        max-width: 100%;

        ::v-deep .multiselect {
            min-height: 38px;

            .multiselect__tags {
                min-height: 38px;
                height: 38px;
                padding: 6px 30px 0 12px;
                border-radius: 8px;
                border: 1px solid $input-border;
                background: #FFFFFF;
                font-size: 13px;
                color: $ink-body;
            }

            .multiselect__placeholder {
                margin-bottom: 0;
                padding-top: 2px;
                color: #8C9F98;
                font-size: 12.5px;
            }

            .multiselect__single {
                margin-bottom: 0;
                padding-top: 2px;
                font-size: 13px;
                color: $ink-body;
                line-height: 20px;
            }

            .multiselect__select { height: 36px; width: 32px; padding: 4px 6px; }

            &.multiselect--active .multiselect__tags {
                border-color: $deep-pine;
                box-shadow: 0 0 0 2px rgba(2, 56, 49, 0.1);
            }
        }
    }
}

.btn-filter-search {
    width: 40px;
    height: 38px;
    background-color: $deep-pine;
    border: 1px solid $deep-pine;
    color: #FFFFFF;
    border-radius: 8px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 13px;
    transition: all 0.2s;

    &:hover:not(:disabled) { background-color: $deep-pine-hover; border-color: $deep-pine-hover; }
    &:disabled { opacity: 0.7; cursor: not-allowed; }
}

.btn-filter-reset {
    height: 38px;
    background-color: #FFFFFF;
    border: 1px solid $input-border;
    color: $ink-body;
    font-size: 12.5px;
    font-weight: 500;
    padding: 6px 18px;
    border-radius: 8px;
    transition: all 0.2s;

    &:hover:not(:disabled) { background-color: #F4F7F5; border-color: #BAC9C2; color: $ink-heading; }
    &:disabled { opacity: 0.6; cursor: not-allowed; }
}

.table-responsive-wrapper { overflow-x: auto; }

.custom-data-table {
    border-collapse: separate;
    border-spacing: 0;
    width: 100%;

    ::v-deep thead th {
        background-color: #F6F7F6;
        border-top: none;
        border-bottom: 1px solid #ECEFEC;
        font-size: 11px;
        font-weight: 600;
        color: #7E918B;
        letter-spacing: 0.1em;
        text-transform: uppercase;
        padding: 14px 20px;
        vertical-align: middle;
        white-space: nowrap;
    }

    ::v-deep tbody tr {
        transition: background-color 0.15s ease;

        &:hover { background-color: #F8FAF9; }

        td {
            padding: 16px 20px;
            border-top: 1px solid #EDF2EF;
            border-bottom: none;
            vertical-align: middle;
            font-size: 13px;
            color: $ink-body;
            font-weight: 500;
        }

        &:first-child td { border-top: none; }
    }
}

.table-pagination-footer {
    border-top: 1px solid #EDF2EF;
    padding: 16px 20px 4px;

    .limit-label { font-size: 12.5px; color: $ink-muted; }

    .limit-select {
        height: 32px;
        width: 70px;
        border-radius: 6px;
        border: 1px solid $input-border;
        font-size: 12.5px;
        color: $ink-body;
        padding: 2px 8px;
        background-color: #FFFFFF;
    }

    .entries-info { font-size: 12px; color: $ink-muted; }
}

.custom-pagination {
    ::v-deep .page-item {
        margin: 0 2px;

        .page-link {
            border-radius: 6px !important;
            border: 1px solid $input-border;
            color: $ink-body;
            font-size: 12px;
            font-weight: 500;
            min-width: 32px;
            height: 32px;
            padding: 0 8px;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            background-color: #FFFFFF;
            box-shadow: none !important;

            &:hover { background-color: #F4F7F5; border-color: #BAC9C2; color: $ink-heading; }
        }

        &.active .page-link {
            background-color: $deep-pine !important;
            border-color: $deep-pine !important;
            color: #FFFFFF !important;
            font-weight: 700;
        }

        &.disabled .page-link {
            opacity: 0.45;
            background-color: #FAFCFA;
            border-color: #E2E7E3;
            color: #A0B0AA;
            cursor: not-allowed;
        }
    }
}

// Tombol Back pada halaman laporan cetak
.btn-back {
    background-color: #FFFFFF;
    border: 1px solid $input-border;
    color: $ink-body;
    border-radius: 8px;
    font-size: 12.5px;
    font-weight: 600;
    padding: 7px 16px;
    transition: all 0.2s ease;

    &:hover { background-color: #F4F7F5; border-color: #BAC9C2; color: $ink-heading; }
}
</style>
